import prepareComponent from "@bluframe/grapple/prepareComponent";
import useUser from "hooks/useUser";
import Navigation from "./Navigation";
const usePrepareComponent = (props) => {
    const { firstName, isAdmin, isEditor, isSocials } = useUser();
    return {
        ...props,
        firstName,
        isAdmin,
        isEditor,
        isSocials
    };
};
export default prepareComponent(usePrepareComponent)(Navigation);
